import { Link } from 'react-router-dom';
import cx from 'classnames';
import { Icon } from '@components/icon/Icon';
import { WideView } from '@components/wideView/WideView';
import { useFeatureFlagContext } from '../featureFlags';
import { Navigation } from '../navigation/Navigation';
import { NavigationMobile } from '../navigation/NavigationMobile';
import { LANDING_PATH } from '../paths';
import styles from './Header.scss';

interface HeaderProps {
  hideBorder?: boolean;
}

export const Header = ({ hideBorder = false }: HeaderProps) => {
  const { isEnabled } = useFeatureFlagContext();
  const headerStyle = hideBorder ? '' : styles.headerBottomBorder;
  const useNewDesign = isEnabled('newGuestLandingPage');

  return (
    <div className={styles.headerContainer}>
      <header className={headerStyle}>
        <Link
          aria-label="Peak home page"
          className={cx(styles.logo, useNewDesign && styles.logoNewDesign)}
          to={LANDING_PATH}
        >
          <Icon name={useNewDesign ? 'peakIcon' : 'logo'} />
        </Link>
        <nav aria-label="primary" className={styles.nav}>
          <WideView
            narrowElement={<NavigationMobile />}
            wideElement={<Navigation />}
          />
        </nav>
      </header>
    </div>
  );
};
